class ImageCarousel extends HTMLElement {
   constructor() {
    super();

    this.slidesContainer = this.querySelector(".image-carousel__slides");  
    this.slides = this.querySelectorAll(".image-carousel__slides__slide");  
    this.arrows = this.querySelectorAll(".image-carousel__arrows button"); 

    this.init();
  }

  init() {

    this.flickity = new Flickity(this.slidesContainer, {
      accessibility: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      contain: true, 
      autoPlay: this.dataset.autoplay == "true" ? (this.dataset.autoplaySpeed ? (this.dataset.autoplaySpeed * 1000) : true) : false,
      selectedAttraction: 0.03,
      friction: 0.8,
      setGallerySize: true,
      percentPosition: false,
      imagesLoaded: true,
      cellAlign: "left"
    });

  // Pause when mouse is anywhere over the carousel (including arrows)
    this.addEventListener("mouseenter", () => {
      console.log("enter");
      this.flickity.stopPlayer();
    });

    this.addEventListener("mouseleave", () => {
      console.log("exit");
      this.flickity.playPlayer();
    });

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
          console.log("click");

          if (arrow.classList.contains("__basic-arrow__prev")) {
              this.flickity.previous(true);
          } else {
              this.flickity.next(true);
          }
      });
    })
  }
}
  
if (!customElements.get('image-carousel')) {
  customElements.define("image-carousel", ImageCarousel);
}
